
import React, { useEffect } from 'react';

/**
 * ChatBubble component that loads the chat functionality across all pages
 * and exposes HubSpot chat widget globally
 */
const ChatBubble: React.FC = () => {
  useEffect(() => {
    // Load the GPTEngineer chat script
    const chatScript = document.createElement('script');
    chatScript.src = 'https://cdn.gpteng.co/gptengineer.js';
    chatScript.type = 'module';
    chatScript.async = true;
    
    // Check if script already exists to avoid duplication
    const existingScript = document.querySelector('script[src="https://cdn.gpteng.co/gptengineer.js"]');
    if (!existingScript) {
      document.body.appendChild(chatScript);
    }

    // HubSpot chat widget is disabled due to 410 Gone errors
    // The script at js-eu1.hs-scripts.com/146139862.js is no longer available
    // To re-enable, update with a valid HubSpot embed code from your HubSpot account

    // Define HubSpotConversations globally for TypeScript
    if (!window.HubSpotConversations) {
      window.HubSpotConversations = {
        widget: {
          open: () => console.log("HubSpot widget not fully loaded yet"),
          close: () => console.log("HubSpot widget not fully loaded yet")
        }
      };
    }

    return () => {
      // We don't remove scripts on unmount to prevent chat from disappearing
    };
  }, []);

  // This is a non-visual component, so it doesn't render anything to the DOM
  return null;
};

// Add TypeScript interface for the global HubSpot object
declare global {
  interface Window {
    HubSpotConversations?: {
      widget: {
        open: () => void;
        close: () => void;
      }
    };
  }
}

export default ChatBubble;
